import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Splash from './components/Splash';
import Home from './pages/Home';
import MemberDetail from './pages/MemberDetail';
import LiveTouring from './pages/LiveTouring';
import ErrorBoundary from './components/ErrorBoundary';
import GalleryDetail from './pages/GalleryDetail';
import PublicHistory from './pages/PublicHistory';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AllMembers from './pages/AllMembers';
import AllGallery from './pages/AllGallery';
import SafetyRiding from './pages/SafetyRiding';

function App() {
  const [showSplash, setShowSplash] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem('blast_splash_seen');
    setShowSplash(!seen);
    setChecked(true);
  }, []);

  const handleEnter = () => {
    sessionStorage.setItem('blast_splash_seen', '1');
    setShowSplash(false);
  };

  if (!checked) return null;

  return (
    <ErrorBoundary>
      <BrowserRouter>
        {showSplash && <Splash onEnter={handleEnter} />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/members" element={<AllMembers />} />
          <Route path="/members/:slug" element={<MemberDetail />} />
          <Route path="/live-touring/:id" element={<LiveTouring />} />
          <Route path="/gallery" element={<AllGallery />} />
          <Route path="/gallery/:albumId" element={<GalleryDetail />} />
          <Route path="/history" element={<PublicHistory />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/safety-riding" element={<SafetyRiding />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
export default App;
